import {
  Broker,
  NestedArea,
  NestedHome,
  NestedMunicipality,
  NestedSpeculator,
} from "@habity/types";
import { SEARCH_CONFIG } from "./search";

const placeholderHome: Partial<NestedHome> = {
  loading: true,
  id: 1,
  agency_id: 1,
  responsible_broker_id: null,
  additional_contact_id: null,
  created_at: "2023-01-01T00:00:00Z",
  updated_at: "2023-01-02T00:00:00Z",
  images: [],
  benefits: ["Home"],
  title: "Beautiful Family Home",
  description:
    "A spacious and modern family home located in a friendly neighborhood.",
  price: 500000,
  is_hidden: false,
  is_price_hidden: false,
  status: {
    id: 1,
    created_at: "2023-01-01T00:00:00Z",
    updated_at: "2023-01-02T00:00:00Z",
    agency_id: 1,
    color_hex: "#FF0000",
    name: "for_sale",
    show_address: true,
    show_broker: true,
    show_in_default_search: true,
    allow_indexing: true,
    show_price: true,
    show_publicly: true,
    show_signed_in: false,
    show_status_badge: false,
    show_verified_badge: false,
    show_public_preview: false,
    is_hidden: false,
    sort_order: 1,
    sync_with_provider: false,
    title: "Active",
    send_matching_emails: false,
    show_features: false,
  },
  address_id: 1,
  address: {
    id: 1,
    agency_id: 1,
    street_id: 1,
    additional_space: 20,
    bedrooms: 4,
    bedrooms_max: 4,
    living_space: 200,
    rooms: 6,
    build_year: 2010,
    street: "123 Main St",
    city: "Springfield",
    zip: "12345",
    country: "USA",
    apartment_number: "4B",
    latitude: 40.7128,
    longitude: -74.006,
    is_rental_unit: false,
    is_verified: true,
    location: null,
    created_at: "2023-01-01T00:00:00Z",
    updated_at: "2023-01-02T00:00:00Z",
    municipality: "Springfield",
    monthly_fee: 0,
    plot_size: null,
    area_id: 1,
    category_boreg: null,
    property_designation: null,
    provider: "internal",
    provider_id: null,
    category: "house",
    search_vector: null,
    municipality_id: null,
    owner_user_id: null,
    ownership: null,
  },
};

export const placeholderHomes = new Array(SEARCH_CONFIG.PER_PAGE.HOMES).fill(
  placeholderHome
);

const placeholderBroker: Broker = {
  loading: true,
  agency_id: 1,
  avatar_id: null,
  avatar_hash: null,
  cloudflare_image_id: null,
  created_at: "2023-01-01T00:00:00Z",
  description: null,
  email: "john.doe@example.com",
  employee_number: null,
  has_avatar: true,
  id: 1,
  location: null,
  name: "John Doe",
  phone: null,
  provider: "internal",
  provider_id: "1",
  rating: null,
  rating_count: null,
  rating_link: null,
  title: null,
  updated_at: null,
  notifications: [],
  office_id: null,
  allow_log_on: false,
  is_active: false,
  is_broker: false,
  is_hidden: false,
  title_user_edited: "",
  municipality_id: null,
  description_title: null,
  description_body: null,
  normalized_name: "",
  has_synced_calendar: false,
  ourly_calendar_id: null,
  cal_username: null,
  cal_onboarding_completed: false,
  cal_invite_sent: false,
  cal_user_id: null,
  cal_meeting_type: "meeting",
};

export const placeholderBrokers = new Array(
  SEARCH_CONFIG.PER_PAGE.BROKERS
).fill(placeholderBroker);

const placeholderSpeculator: NestedSpeculator = {
  loading: true,
  agency_id: 1,
  avatar_fetched: false,
  avatar_url: null,
  broker_id: null,
  buyer_intent: "buy_now",
  buyer_persona: "first_time_home_buyer",
  buyer_status: "activelyLooking",
  buyer_updated_at: new Date().toISOString(),
  created_at: new Date().toISOString(),
  email: "john.doe@example.com",
  first_name: "John",
  id: 1,
  uuid: "1234567890",
  id_country_code: "SE",
  id_name: "Swedish ID",
  // id_number: 1234567890,
  id_verified_at: new Date().toISOString(),
  is_deceased: false,
  last_name: "Doe",
  name: "John Doe",
  onboarding_completed_at: null,
  phone: "+46707777777",
  provider: "internal",
  provider_id: "1",
  role: "buyer",
  sendbird_access_token: null,
  terms_accepted_at: null,
  privacy_policy_accepted_at: null,
  updated_at: new Date().toISOString(),
  app_mode: "buyer",
  areas: [],
  loan_promise: "not_verified",
  loan_promise_expires_at: null,
  loan_contact_accepted_at: null,
  loan_contact_denied_at: null,
  loan_contact_lead_created_at: null,
  loan_contact_lead_id: null,
  address_city: "Stockholm",
  address_country: "Sweden",
  address_street: "Main St",
  address_zip: "12345",
  source: null,
  unsubscribed_at: null,
  match_score: 100,
  is_matching_enabled: null,
  search: {
    additional_space_max: 100,
    additional_space_min: 50,
    agency_id: 1,
    bedrooms_max: 4,
    bedrooms_min: 2,
    build_year_max: 2020,
    build_year_min: 2010,
    categories: ["apartment", "house"],
    city: "Stockholm",
    country: "Sweden",
    created_at: "2023-01-01T00:00:00Z",
    created_by: "user",
    description: null,
    features: ["pool"],
    geom: null,
    id: 1,
    ignore_home_ids: [],
    intent: "buy_now",
    is_auto_populated: false,
    is_claimed: false,
    is_hidden: false,
    is_rental_unit: false,
    label: null,
    last_viewed_at: null,
    latitude: 59.3293,
    latitude_max: null,
    latitude_min: null,
    living_space_max: 100,
    living_space_min: 50,
    locations: null,
    location: null,
    locations_legacy: null,
    longitude: 18.0686,
    longitude_max: null,
    longitude_min: null,
    monthly_fee_max: 10000,
    monthly_fee_min: 5000,
    municipality: "Stockholm",
    nearby: ["school"],
    owner_id: 1,
    persona: "first_time_home_buyer",
    places: ["Stockholm"],
    plot_size_max: 1000,
    plot_size_min: 500,
    preferences: ["gym", "pool"],
    price_max: 10000000,
    price_min: 5000000,
    provider: "internal",
    provider_id: null,
    origin: "internal",
    rooms_max: 4,
    rooms_min: 2,
    status: "activelyLooking",
    statuses: ["offmarket"],
    streets: ["Main St"],
    title: null,
    updated_at: "2023-01-02T00:00:00Z",
    updated_by: "user",
    valid_until: null,
    zips: ["12345"],
    notification_channels: [],
    homes: [],
  },
};

export const placeholderAreas: NestedArea[] = Array(6)
  .fill(0)
  .map((_, i) => ({
    agency_id: 1,
    created_at: new Date().toISOString(),
    description: null,
    has_image: false,
    id: i + 1,
    image_url: null,
    is_hidden: false,
    location: null,
    municipality_code: null,
    municipality_id: null,
    name: `Area ${i + 1}`,
    provider: "internal",
    provider_data: null,
    provider_id: `${i + 1}`,
    updated_at: new Date().toISOString(),
    place_id: null,
    sold_homes_count: 0,
    for_sale_homes_count: 0,
    archived: false,
    cloudflare_map_image_card_id: null,
    cloudflare_map_image_hero_id: null,
    cloudflare_map_image_id_hero: null, // Old column name - will be removed after migration
    rating: null,
    rating_count: null,
    rating_link: null,
    rating_source: null,
    rating_updated_at: null,
  }));

export const placeholderMunicipalities: NestedMunicipality[] = Array(6)
  .fill(0)
  .map((_, i) => ({
    agency_id: 1,
    created_at: new Date().toISOString(),
    description: null,
    has_image: false,
    id: i + 1,
    image_url: null,
    importance: Math.random() * 10,
    location: null,
    municipality_code: null,
    name: `Municipality ${i + 1}`,
    provider: "internal",
    provider_data: null,
    provider_id: `${i + 1}`,
    updated_at: new Date().toISOString(),
    homes_count: Math.floor(Math.random() * 100) + 1,
    areas_count: Math.floor(Math.random() * 8) + 1,
    brokers_count: Math.floor(Math.random() * 5) + 1,
    geometry: null,
    osm_id: null,
    osm_type: null,
    county_id: null,
    place_id: null,
    is_correct: null,
    sold_homes_count: 0,
    for_sale_homes_count: 0,
    rating: null,
    rating_count: null,
    rating_link: null,
    rating_source: null,
    rating_updated_at: null,
    cloudflare_map_image_card_id: null,
    cloudflare_map_image_hero_id: null,
    cloudflare_map_image_id_hero: null, // Old column name - will be removed after migration
  }));

export const placeholderSpeculators = new Array(
  SEARCH_CONFIG.PER_PAGE.BUYERS
).fill(placeholderSpeculator);
